import { render, staticRenderFns } from "./forgetPSWPage.vue?vue&type=template&id=23e97279&scoped=true"
import script from "./forgetPSWPage.vue?vue&type=script&lang=js"
export * from "./forgetPSWPage.vue?vue&type=script&lang=js"
import style0 from "./forgetPSWPage.vue?vue&type=style&index=0&id=23e97279&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e97279",
  null
  
)

export default component.exports